import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal from '../../common/Modal';
import EmergencyPerson from '../../../images/EmergencyPerson.svg';
import { FaChevronRight } from 'react-icons/fa';
import EmergencyInfo from '../../../images/EmergencyInfo.svg';
import RelationDropDown from './RelationDropDown';
import { Link, useHistory } from 'react-router-dom';
import {
  addEmergencyContact,
  editEmergencyContact,
  fetchRelativeId,
  markContactsInactive,
} from '../../../services';
import { showError } from '../../../actions';
import { FlyInTransition } from '../../../components/transitions/transitions';
import LoadingComponent from '../../../components/common/LoadingComponent';

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f6;
  padding: 16px 20px;
`;

const HeadText = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #0f0b28;
`;

const HeadImg = styled.img``;

const HeadSkipContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const HeadSkip = styled.p`
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #585969;
`;

const DescContainer = styled.div`
  padding: 16px 10px;
  margin-top: 16px;
  display: flex;
  align-self: center;
  gap: 10px;
  background: rgba(207, 200, 255, 0.32);
  border-radius: 8px;
`;

const DescText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 140%;
  letter-spacing: 0.25px;
  color: #585969;
`;

const DescImg = styled.img`
  height: 12px;
  width: 12px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  gap: 8px;
`;

const NameText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
`;

const NameInput = styled.input`
  background: #f8f9fb;
  border-radius: 12px;
  font-size: 12px;
  padding: 12px;
`;

const Line = styled.div`
  border-bottom: 1px solid #f0f3f6;
  margin-top: 30px;
`;

const ConsentContainer = styled.div`
  display: flex;
  padding: 16px 20px;
  align-items: start
  gap: 10px;
`;

const ConsentText = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  color: #0f0b28;
`;

const ConsentInput = styled.input``;

const SubmitY = styled.button`
  display: flex;
  padding: 14px 160px;
  color: #ffffff;
  text-align: center;
  gap: 10px;
  width: 90%;
  background: var(--primary-button);
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;
  border-radius: 12px;
  margin-left: 25px;
`;

const SubmitN = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 160px;
  color: rgba(0, 0, 0, 0.2);
  text-align: center;
  gap: 10px;
  width: 90%;
  background: rgba(228, 228, 228, 0.5);
  cursor: default;
  font-family: 'var(--font-secondary)';
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;
  border-radius: 12px;
  margin-left: 25px;
`;

const EmergencyContactMenu = (props) => {
  const [relation, setRelation] = useState('');
  const [canSubmit, setCanSubmit] = useState(false);
  const [consent, setConsent] = useState(false);
  const history = useHistory();

  const [data, setData] = useState({
    name: props.valueEdit && props.valueEdit.name ? props.valueEdit.name : '',
    contact:
      props.valueEdit && props.valueEdit.emergencyContact
        ? String(props.valueEdit.emergencyContact)
        : '',
    relation: '',
  });

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleCheck = () => {
    setConsent((prev) => !prev);
    if (
      data.name === '' ||
      data.contact === '' ||
      !data.relation.length ||
      data.contact.length < 10 ||
      data.contact.length > 10
    ) {
      setCanSubmit(false);
    } else {
      setCanSubmit(true);
    }
  };

  useEffect(() => {
    if (data.contact.length < 10 || data.contact.length > 10) {
      setCanSubmit(false);
    }
    if (data.contact.length > 10) {
      setData({ ...data, contact: data.contact.slice(0, 10) });
    }
  }, [data.contact]);

  useEffect(() => {
    if (props.length !== 0 || props.isEdit) {
      if (
        data.name &&
        data.name.length > 0 &&
        data.contact &&
        data.contact.length === 10 &&
        data.relation &&
        data.relation.length > 0
      ) {
        setCanSubmit(true);
        setConsent(true);
      } else {
        setCanSubmit(false);
        setConsent(false);
      }
    } else if (consent && props.length === 0) {
      if (
        data.name &&
        data.name.length > 0 &&
        data.contact &&
        data.contact.length === 10 &&
        data.relation &&
        data.relation.length > 0 &&
        consent
      ) {
        setCanSubmit(true);
      } else {
        setCanSubmit(false);
      }
    }
  }, [data]);

  const handleSkip = () => {
    markContactsInactive(props.information)
      .then((res) => {
        if (res.message === 'success') {
          props.information.hideModal();
        }
      })
      .catch((err) => {
        showError(err.message);
      });
  };

  const handleRelationChange = (value) => {
    console.log(value[0], 'value relation');
    setData({ ...data, relation: value[0] });
  };

  const handleContact = (props) => {
    const addContact = async () => {
      try {
        const consultationDetails = await fetchRelativeId(props.information);
        const saveContact = await addEmergencyContact(
          props,
          data,
          consultationDetails.relativeId
        );
        console.log(saveContact, 'saveContact');
        if (saveContact.message === 'success') {
          if (props.length !== 0 || props.isEdit) {
            window.location.reload();
          } else {
            props.information.hideModal();
          }
        }
      } catch (err) {
        showError(err);
      }
    };
    const editContact = async () => {
      try {
        const consultationDetails = await fetchRelativeId(props.information);
        const editContact = await editEmergencyContact(
          props,
          data,
          consultationDetails.relativeId
        );
        console.log(editContact, 'editContact');
        if (editContact.message === 'success') {
          window.location.reload();
        }
      } catch (err) {
        showError(err);
      }
    };
    if (props.toAdd) addContact();
    else if (props.isEdit) editContact();
    else addContact();
  };

  return (
    <Modal>
      <div className="modalContainer">
        <FlyInTransition in={true} mountOnEnter unmountOnExit appear>
          {props?.isLoading ? (
            <LoadingComponent />
          ) : (
            <div className="modalBody">
              <MenuContainer
                style={
                  props.length === 0 && !props.isEdit
                    ? { height: '560px' }
                    : { height: '500px' }
                }
              >
                <Head>
                  <HeadSkipContainer className="flex items-center">
                    <HeadImg src={EmergencyPerson}></HeadImg>
                    <HeadText>Emergency Contact</HeadText>
                  </HeadSkipContainer>
                  <HeadSkipContainer onClick={() => handleSkip()}>
                    <HeadSkip>Skip</HeadSkip>
                    <FaChevronRight
                      style={{
                        height: '8px',
                        width: '7.6px',
                      }}
                    />
                  </HeadSkipContainer>
                </Head>
                <DescContainer>
                  <DescImg src={EmergencyInfo} />
                  <DescText>
                    Emergency contact will only be used in case of any serious
                    cases.
                  </DescText>
                </DescContainer>
                <Form>
                  <NameContainer>
                    <NameText>Name</NameText>
                    <NameInput
                      type="text"
                      name="name"
                      value={data.name}
                      placeholder="Enter Name"
                      onChange={handleInputChange}
                    />
                  </NameContainer>
                  <NameContainer>
                    <NameText>Contact Number</NameText>
                    <NameInput
                      type="number"
                      name="contact"
                      value={data.contact}
                      placeholder="Enter Contact Number"
                      onChange={handleInputChange}
                    />
                  </NameContainer>
                  <NameContainer>
                    <NameText>Relation</NameText>
                    <RelationDropDown
                      data={data}
                      trigger={handleRelationChange}
                    />
                  </NameContainer>
                </Form>
                <Line />
                {props.length === 0 && !props.isEdit && (
                  <ConsentContainer>
                    <ConsentInput
                      type="checkbox"
                      onClick={() => handleCheck()}
                    />
                    <ConsentText>{props.consentText}</ConsentText>
                  </ConsentContainer>
                )}
                <div className="w-full">
                  {canSubmit && consent ? (
                    <SubmitY onClick={() => handleContact(props)}>
                      Submit
                    </SubmitY>
                  ) : (
                    <SubmitN>Submit</SubmitN>
                  )}
                </div>
              </MenuContainer>
            </div>
          )}
        </FlyInTransition>
      </div>
    </Modal>
  );
};

export default EmergencyContactMenu;
